import _ from 'lodash'
import React from 'react'
import AccountCircle from '@mui/icons-material/AccountCircle'
import GroupWork from '@mui/icons-material/GroupWork'
import Public from '@mui/icons-material/Public'

import Sockette from '../util/sockette'
import { getAuthentication } from '../security/securityContext'
import store from '../store/configureStore'
import {
  recuperarAlertas,
  tratarComunicacaoAtualizada,
  tratarComunicacaoProcessualCriada,
  tratarDocumentoAtualizado,
  tratarProcessoAdmAtualizado,
  tratarProcessoAtualizado
} from '../actions/alertasActions'
import { retryWaitingFor } from '../components/util/retryUtil'

let webSocket

export const iniciarWebSocket = () => {
  const context =
    window.location.hostname === 'localhost'
      ? `${window.location.hostname}:8000`
      : `${window.location.hostname}/bff`
  const websocketPrefix = window.location.href.startsWith('https') ? 'wss' : 'ws'
  webSocket = Sockette(`${websocketPrefix}://${context}/publico/alertas/websocket`, {
    timeout: 6e4,
    // maxAttempts: 10,
    onopen: (e) => join(e),
    onmessage: (e) => receiveMessage(e),
    onreconnect: (e) => log('Alertas webSocket reconnecting...', e),
    onmaximum: (e) => log('Alertas webSocket reconnect attempting stopped!', e),
    onclose: (e) => log('Alertas webSocket closed!', e),
    onerror: (e) => log('Alertas webSocket error:', e)
  })
  return webSocket
}

export const ESCOPOS_NOTIFICACAO = {
  PESSOAL: {
    codigo: 'PESSOAL',
    icone: <AccountCircle style={{ color: '#2E6F8C' }} />,
    color: '#2E6F8C'
  },
  UNIDADE: {
    codigo: 'UNIDADE',
    icone: <GroupWork style={{ color: '#876ACA' }} />,
    color: '#876ACA'
  },
  GLOBAL: { codigo: 'GLOBAL', icone: <Public style={{ color: '#12BFF2' }} />, color: '#12BFF2' }
}

export const encerrarWebSocket = () => {
  if (webSocket) {
    webSocket.close(1000)
  }
}

export const restartWebSocket = () => {
  console.log('Restart webSocket requested!')
  encerrarWebSocket()
  _.delay(iniciarWebSocket, 1200)
}

const log = (msg, e) => {
  console.log(msg, e)
}

const join = (e) => {
  log('Alertas webSocket connected!', e)
  const auth = getAuthentication()
  if (!auth || !auth.isUserAuthenticated) {
    return
  }
  const login = auth.username
  const {
    contextoWebSocket: { codigoUsuario, ready, codigoUsuarioSelecionado }
  } = store.getState()
  if (!ready) {
    retryWaitingFor(
      () => {
        const {
          contextoWebSocket: {
            codigoUsuario: codigoUsuarioDelayed,
            ready: readyDelayed,
            codigoUsuarioSelecionado: codigoUsuarioSelecionadoDelayed
          }
        } = store.getState()
        const shouldRetry = _.isNil(codigoUsuarioDelayed) || readyDelayed === false
        if (!shouldRetry) {
          sendMessage({
            type: 'join',
            data: {
              login,
              codigoUsuario: codigoUsuarioDelayed,
              codigoUsuarioSelecionado: codigoUsuarioSelecionadoDelayed
            }
          })
        }
        return shouldRetry
      },
      1500,
      60
    )
  } else {
    sendMessage({ type: 'join', data: { login, codigoUsuario, codigoUsuarioSelecionado } })
  }
}

const sendMessage = (message) => {
  try {
    webSocket.send(JSON.stringify(message))
  } catch (err) {
    console.log(err)
    _.delay(() => sendMessage(message), 5000)
  }
}

const doTratarProcessoAtualizado = ({ data: processo }) => {
  const {
    filtros: { unidadesAtuais }
  } = store.getState()
  const notificarUnidadesAtuais = Boolean(unidadesAtuais[processo.codigoUnidadeResponsavelTecnica])
  // log('processo-atualizado', processo.codigoProcesso)
  // log('notificar-unidades-atuais', notificarUnidadesAtuais)
  store.dispatch(
    tratarProcessoAtualizado(
      processo.codigoProcesso,
      processo.numeroFormatado,
      notificarUnidadesAtuais
    )
  )
}

const doTratarProcessoAdmAtualizado = ({ data: processoAdm }) => {
  // log('processo-administrativo-atualizado', processoAdm)
  const { codigoProcesso, codigoUsuario } = processoAdm
  store.dispatch(tratarProcessoAdmAtualizado(codigoProcesso, codigoUsuario))
}

const doTratarComunicacaoProcessualCriada = ({ data: comunicacaoProcessualCriada }) => {
  // log('comunicacao-processual-criada', comunicacaoProcessualCriada)
  const { codigoProcesso, codigoComunicacao, codigoUsuario } = comunicacaoProcessualCriada
  store.dispatch(
    tratarComunicacaoProcessualCriada(codigoProcesso, codigoComunicacao, codigoUsuario)
  )
}

const doTratarComunicacaoAtualizada = ({ data: comunicacao }) => {
  // log('comunicacao-atualizado', comunicacao)
  const { codigoComunicacao, codigoUsuario } = comunicacao
  store.dispatch(tratarComunicacaoAtualizada(codigoComunicacao, codigoUsuario))
}

const doTratarDocumentoAtualizado = ({ data: documento }) => {
  // log('documento-atualizado', documento)
  const { codigoDocumento, codigoUsuario } = documento
  store.dispatch(tratarDocumentoAtualizado(codigoDocumento, codigoUsuario))
}

const doRecuperarAlertasUnidades = ({ data: codigosUnidadesNotified }) => {
  const state = store.getState()
  const {
    filtros: { unidadesAtuais }
  } = state
  const codigosUnidadesFiltered = _.filter(codigosUnidadesNotified, (codigoUnidadeNotified) =>
    Boolean(unidadesAtuais[codigoUnidadeNotified])
  )
  if (_.size(codigosUnidadesFiltered)) {
    // Ao menos um codigoUnidadeNotified é um dos codigosUnidadesAtuais...
    // log('recuperar-alertas-unidades', _.keys(unidadesAtuais))
    store.dispatch(recuperarAlertas())
  }
}

const doRecuperarAlertasUsuarios = ({ data: codigoUsuario }) => {
  // log('recuperar-alertas-usuarios', codigoUsuario)
  store.dispatch(recuperarAlertas())
}

const receiveMessage = (e) => {
  // log('Alertas webSocket message received:', e)
  const data = JSON.parse(e.data)
  switch (data.type) {
    case 'processo-atualizado':
      doTratarProcessoAtualizado(data)
      break
    case 'processo-administrativo-atualizado':
      doTratarProcessoAdmAtualizado(data)
      break
    case 'comunicacao-processual-criada':
      doTratarComunicacaoProcessualCriada(data)
      break
    case 'comunicacao-atualizado':
      doTratarComunicacaoAtualizada(data)
      break
    case 'documento-atualizado':
      doTratarDocumentoAtualizado(data)
      break
    case 'notificacoes-unidades':
      doRecuperarAlertasUnidades(data)
      break
    case 'notificacoes-usuarios':
      doRecuperarAlertasUsuarios(data)
      break
    default:
      log(`"${data.type}" action handler não implementado!`)
  }
}
